import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const manageItems = [
  "WHS documents and policies",
  "Digital WHS forms",
  "Safety inspections and audits",
  "Incident and hazard reporting",
  "Corrective actions",
  "Contractor compliance",
  "SWMS and risk assessments",
  "Employee and training records",
  "Plant and asset registers",
  "Site management",
  "Compliance tasks and reporting",
];

function CheckIcon() {
  return (
    <span className="complete-whs-check" aria-hidden="true">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 9.75L7.125 13.125L14.25 4.875"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

function CompleteWHSCompliance() {
  return (
    <section className="py-5 complete-whs-section" id="complete-whs-compliance">
      <Container>
        <div className="complete-whs-header text-center">
          <h2 className="complete-whs-title">
            Complete WHS & Safety Compliance Software for Australian Businesses
          </h2>
          <p className="complete-whs-intro mx-auto">
            Complimate is an Australian compliance management software platform
            designed to help businesses manage work health and safety, safety
            compliance and everyday compliance tasks in one place.
          </p>
          <p className="complete-whs-intro mx-auto">
            From digital forms and workplace inspections to documents, audits,
            corrective actions and contractor management, Complimate helps teams
            organise their safety management systems and keep important
            compliance information accessible.
          </p>
        </div>

        <div className="complete-whs-manage">
          <p className="complete-whs-manage-title">Businesses can manage:</p>
          <Row className="g-3 complete-whs-grid">
            {manageItems.map((item) => (
              <Col key={item} xs={12} sm={6} lg={4}>
                <div className="complete-whs-item">
                  <CheckIcon />
                  <span>{item}</span>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <p className="complete-whs-closing text-center mx-auto">
          Built for Australian businesses across industries, Complimate brings
          practical WHS software and safety management software into one
          connected platform.
        </p>
      </Container>
    </section>
  );
}

export default CompleteWHSCompliance;
